$(document).off("change", "#hire_status")
$(document).on("change", "#hire_status", function(){
  $("#hire_department_id").attr("disabled", "disabled")
  $("#hire_position_id").attr("disabled", "disabled")
  $("#contract-select").attr("disabled", "disabled")

  $("#hire_department_id").closest(".col-12").addClass("d-none")
  $("#hire_position_id").closest(".col-12").addClass("d-none")
  $("#contract-select").closest(".col-12").addClass("d-none")
  if ($(this).val() == "hired") {
    $("#hire_department_id").removeAttr("disabled")
    $("#hire_position_id").removeAttr("disabled")
    $("#contract-select").removeAttr("disabled")

    $("#hire_department_id").closest(".col-12").removeClass("d-none")
    $("#hire_position_id").closest(".col-12").removeClass("d-none")
    $("#contract-select").closest(".col-12").removeClass("d-none")
  }
})